export default {
  init() {
    // JavaScript to be fired on all pages
    $(document).ready(function () {
      if ($(".hero-carousel").length) {
        $(".hero-carousel").owlCarousel({
          items: 1,
          margin: 10,
          autoplay: false,
          autoplayTimeout: 7000,
          autoplayHoverPause: true,
          rewind: true
        });
      }
      if ($(".employee-carousel").length) {
        $(".employee-carousel").owlCarousel({
          items: 1,
          autoHeight: true
        });
      }

      $(".contact-form-block:not(.lahjakortti) select option:first-child").each(function () {
        $(this).attr({ disabled: true, default: true });
      });
    });

    $(".togglemenu").click(function () {
      $(this).toggleClass("nav-open");
      $("header .logo").toggleClass("menu-open");
      $(".nav-primary").toggleClass("open");
    });

    $("#show-more-personnel").click(function () {
      $(this)
        .parent()
        .hide();
      $(".person.hidden").toggle();
    });

    $("#show-more-products").click(function () {
      $(this).toggleClass("open");
      if ($(this).hasClass("open")) {
        // eslint-disable-next-line no-undef
        $(this).html(strings.showLessProducts);
      } else {
        // eslint-disable-next-line no-undef
        $(this).html(strings.showMoreProducts);
      }
      $(".product.hidden").toggle();
    });

    $(".menu-item-has-children .sub-menu-toggle").click(function () {
      $(this).toggleClass("rotate");
      $(this)
        .parent()
        .find(".sub-menu")
        .slideToggle();
    });

    $(".product-accordion-title").click(function () {
      $(this).closest(".product-accordion").toggleClass("open");
    });

    // laatukriteeriform imgz
    function readURL(input, thing) {

      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function(e) {
          thing.parent().addClass('uploaded');
          thing.parent().find('img').remove();
          thing.parent().append('<img src="'+e.target.result+'">');
        }

        reader.readAsDataURL(input.files[0]);
      }
    }

    $('body').on('change', '.acf-image-uploader input[type=file]', function() {
      readURL( this, $(this) );
    });

    var form = $('#new-form'),
    original = form.serialize()

    form.submit(function(){
      window.onbeforeunload = null;
    });

    window.onbeforeunload = function(){
      if (form.serialize() != original)
        return 'Are you sure you want to leave?';
    }

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    /* $(document).ready(function() {
      $(".gm-style-iw").each(function() {
        var parent = $(this).parent();
        var height = parent.height;
        parent.addClass("infowindow-parent");
        parent.css("top", height);
      });
    }); */
  }
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js